import {CommonMessages} from '../common.messages';

export const ClientEntitiesMessages = {
    GetCountriesFailed: {
        key: 'GetCountriesFailed',
        message: 'Error while processing the server request. Get information about countries failed.'
    },
    GetCountriesInvalidData: {
        key: 'GetCountriesInvalidData',
        message: 'Error while processing the server request. Information about system countries is invalid.'
    },
    UserSearchFailed: {
        key: 'UserSearchFailed',
        message: 'Error while processing the server request. Get information about clients failed.'
    },
    GetRolesFailed: {
        key: 'GetRolesFailed',
        message: 'Error while processing server request. Cannot get available operator roles.'
    },
    GetTradingPlatformsFailed: {
        key: 'GetTradingPlatformsFailed',
        message: 'Error while processing server request. Cannot get all trading platforms.'
    },
    ConfirmOperatorDeletionDialogCaption: {
        key: 'ConfirmOperatorDeletionDialogCaption',
        message: 'Delete Operator'
    },
    ConfirmOperatorDeletionDialogQuestion: {
        key: 'ConfirmOperatorDeletionDialogQuestion',
        message: 'Are you sure you want to delete <<name>>'
    },
    OperatorDeletionFailed: {
        key: 'OperatorDeletionFailed',
        message: 'Error while request processing. Unable to delete <<name>>.'
    },
    OperatorDeletionSucceed: {
        key: 'OperatorDeletionSucceed',
        message: '<<name>> is successfully deleted.'
    },
    NotFoundExportData: {
        key: 'NotFoundExportData',
        message: 'Error while communication with the server. Can\'t find data to export.'
    },
    ...CommonMessages
};
